import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../../shared/components/LoadingOverlay';
import taskGroupsActions from '../../../store/task-groups/action-creators';
import taskGroupsSelectors from '../../../store/task-groups/selectors';
import CloseActionButton from '../../common/CloseActionButton';
import TaskForm from './TaskForm';

class TaskGroupTaskEdit extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedTaskGroup) {
      return {
        task: nextProps.selectedTaskGroup.tasks.find((task) => {
          return task.taskGuid === nextProps.match.params.taskGuid;
        }),
      };
    }
    return { ...prevState };
  }

  constructor(props) {
    super(props);
    this.state = { task: null };
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.match.params.taskGroupGuid !== this.props.selectedGuid) {
      this.props.setSelectedTaskGroup(this.props.match.params.taskGroupGuid);
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  onClose() {
    if(this.props.userContext.hasScope('admin')) {
      const url = `/admin/task-groups/${this.props.match.params.taskGroupGuid}`;
      this.props.history.push(url);
    } else {
      const url = `/task-groups/${this.props.match.params.taskGroupGuid}`;
      this.props.history.push(url);
    }
  }

  onSave(properties) {
    const formData = {
      ...properties,
      taskGuid: this.state.task.taskGuid,
    };
    this.props.updateTaskGroupTask(formData).then(() => this.onClose());
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.selectedTaskGroup;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">
                {this.props.selectedTaskGroup.name}: Edit Task
              </h4>
              <CloseActionButton label="Edit Task" onClose={this.onClose} />
            </div>
            <div className="app-content">
              <TaskForm
                initialValues={this.state.task}
                isLoading={this.props.isLoading}
                onSave={this.onSave}
              />
            </div>
          </Fragment>
        )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    selectedGuid: state.taskGroups.selectedGuid,
    selectedTaskGroup: taskGroupsSelectors.selectedTaskGroup(state),
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedTaskGroup: (taskGroupGuid) => {
      return dispatch(taskGroupsActions.setSelectedTaskGroup(taskGroupGuid));
    },
    updateTaskGroupTask: formData =>
      dispatch(taskGroupsActions.updateTaskGroupTask(formData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupTaskEdit);
